import React, { FC, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { useAppQuery } from '../../hooks/index';
import { ApiService } from '../../services/index';
import { inviteStakeholderStore } from '../../storage/local/index';
import { Invitation } from '../../types/invitation.types';
import { PageRoute } from '../../types/page.types';

const AcceptInvitation: FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    data: invitation,
    isPending,
    isError,
  } = useAppQuery({
    queryKey: [QueryKey.GET_INVITATION, id],
    queryFn: () =>
      ApiService.get<Invitation>({ endpoint: BackendRoute.INVITATIONS, routePath: [id || ''] }),
    enabled: !!id,
    defaultErrorHandling: false,
    retry: false,

    onError: () => {
      navigate('/error-page');
    },
  });

  useEffect(() => {
    if (isPending || !invitation || isError) return;

    inviteStakeholderStore.set({
      id,
      email: invitation.email,
      isRegistered: invitation.isUserRegistered,
      isAccepted: false,
    });

    navigate(invitation.isUserRegistered ? PageRoute.HOME : PageRoute.REGISTER);
  }, [id, invitation, isPending, isError, navigate]);

  return <></>;
};

export default AcceptInvitation;
